export default "4ad713449a0946a7.png"